module.exports = __webpack_public_path__ + "img/listening-feedback.7ec917ed.svg";